export const noteDraftConstant = {
    GET_BY_PERSON: 'NOTE_DRAFT_GET_BY_PERSON',
    EDIT: 'NOTE_DRAFT_EDIT',
    CLOSE: 'NOTE_DRAFT_CLOSE',
    CHANGE: 'NOTE_DRAFT_CHANGE',
    SAVED: 'NOTE_DRAFT_SAVED',
    SIGNED: 'NOTE_DRAFT_SIGNED'
};
